@if (isLoading()) {
  <div class="ion-text-center ion-padding ion-margin-top">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Cargando detalles de la importación...</p>
  </div>
} @else {
  @if (batchImportRows(); as item) {
    <ion-list class="ion-margin-horizontal-negative ion-padding-top-0">
      <ion-item-group>
        <ion-item-divider sticky>
          <ion-label>Error en filas</ion-label>
        </ion-item-divider>

        @for (batchImportRow of batchImportRows(); track batchImportRow.id) {
          <ion-item>
            <ion-grid>
              <ion-row>
                <ion-col
                  class="ion-align-self-center"
                  size="1"
                  size-lg="2"
                >
                  <p>
                    {{ batchImportRow.rowNumber }}
                  </p>
                </ion-col>
                <ion-col
                  class="ion-align-self-center"
                  size="3"
                  size-lg="2"
                >
                  <p>
                    {{ batchImportRow.errorCode }}
                  </p>
                </ion-col>
                <ion-col
                  class="ion-align-self-center"
                  size="8"
                  size-lg="6"
                >
                  <p>
                    {{ 'batchImport.errors.' + batchImportRow.errorCode | translate }}
                  </p>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-item>
        } @empty {
          <ion-item>
            <ion-label>
              <p class="fs-sm ion-text-center">No hay errores de importación</p>
            </ion-label>
          </ion-item>
        }
      </ion-item-group>
    </ion-list>
  }
}
